__turbopack_context__.v({
  "className": "inter_c8e4a368-module__zwF8vW__className",
  "variable": "inter_c8e4a368-module__zwF8vW__variable",
});
